/**
 * Find ancestor
 * @param el
 * @param selector
 * @returns HTMLElement|null
 */
export function findAncestor(el, selector) {
    // noinspection StatementWithEmptyBodyJS
    while ((el = el.parentElement) && !((el.matches || el.matchesSelector).call(el, selector))) {

    }

    return el
}

/**
 * Get next sibling. Possibility to specify a selector.
 * @param elem
 * @param selector
 * @returns {Element}
 */
export function getNextSibling(elem, selector) {
    // Get the next sibling element
    let sibling = elem.nextElementSibling

    // If there's no selector, return the first sibling
    if (!selector) {
        return sibling
    }

    // If the sibling matches our selector, use it
    // If not, jump to the next sibling and continue the loop
    while (sibling) {
        if (sibling.matches(selector)) {
            return sibling
        }

        sibling = sibling.nextElementSibling
    }
}

/**
 * Get previous sibling. Possibility to specify a selector.
 * @param elem
 * @param selector
 * @returns {Element}
 */
export function getPreviousSibling(elem, selector) {
    // Get the next sibling element
    let sibling = elem.previousElementSibling

    // If there's no selector, return the first sibling
    if (!selector) {
        return sibling
    }

    // If the sibling matches our selector, use it
    // If not, jump to the next sibling and continue the loop
    while (sibling) {
        if (sibling.matches(selector)) {
            return sibling
        }

        sibling = sibling.previousElementSibling
    }
}

/**
 * Check if element is visible.
 * offsetParent === null, if display 'none' is set.
 * Some browsers returns offsetParent === null for fixed elements, therefore we check width width and height.
 * This function doesn't work for fixed elements where width and height is intentionally set to 0.
 * @param el
 * @returns {boolean}
 */
export function isElementVisible(el) {
    return !(!el.offsetParent && el.offsetWidth === 0 && el.offsetHeight === 0);
}

/**
 * Converts 6 character hex code to rgba. Works with or without the # character.
 * @param hex
 * @param alpha
 * @returns {`rgba(${*},${*},${*},1)`}
 */
export const hex2rgba = (hex, alpha = 1) => {
    const [r, g, b] = hex.match(/\w\w/g).map(x => parseInt(x, 16))
    return `rgba(${r},${g},${b},${alpha})`
}